module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-933-retro.2d6cba22.jpg";